import { render, staticRenderFns } from "./GridTwoColumn.vue?vue&type=template&id=6b3fd71a&"
import script from "./GridTwoColumn.vue?vue&type=script&lang=js&"
export * from "./GridTwoColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports